import Shield from '@/assets/icons/common/shield.svg';
import { useTranslate } from '@/hooks/useTranslate';

export const Disclaimer = () => {
  const { t } = useTranslate();

  return (
    <div className="flex flex-row items-center gap-1">
      <img src={Shield} alt="Shield" className="w-4.5 h-4.5" />
      <div className="text-[12px] text-muted-foreground">{t('allPaymentsSecureAndEncrypted')}</div>
    </div>
  );
};
